module.exports = __webpack_public_path__ + "img/ts_cust_supp.1f61f083.png";